<div class="sn-toolbar" *ngIf="{update: updateAvailable$ | async, page: currentPage$ | async, mode: menuMode$ | async, available: menuAvailable$ | async} as vm">
  <div *ngIf="vm.available" class="sn-layout-switch" role="group" aria-label="Menu layout">
    <button type="button" class="sn-layout-switch__option" [class.sn-layout-switch__option--on]="vm.mode === 'top'"
            [attr.aria-pressed]="vm.mode === 'top'" title="Menu across the top" (click)="setMenuMode('top')">
      <i class="fa-solid fa-window-maximize" aria-hidden="true"></i><span class="sr-only">Top menu</span>
    </button>
    <button type="button" class="sn-layout-switch__option" [class.sn-layout-switch__option--on]="vm.mode === 'side'"
            [attr.aria-pressed]="vm.mode === 'side'" title="Menu down the side" (click)="setMenuMode('side')">
      <i class="fa-solid fa-table-columns" aria-hidden="true"></i><span class="sr-only">Side menu</span>
    </button>
  </div>

  <span *ngIf="vm.update" class="sn-toolbar__update-wrap">
    <button type="button" class="sn-toolbar__update" (click)="update()" aria-describedby="sn-update-hint">
      <i class="fa-solid fa-arrow-rotate-right" aria-hidden="true"></i>
      <span class="sn-toolbar__update-label">Click to Update (New Version)</span>
      <span class="sn-toolbar__update-short" aria-hidden="true">Update</span>
    </button>
    <span id="sn-update-hint" class="sr-only">A new version of Snöball is available. Reloading the page updates it.</span>
    <span *ngIf="confirmingUpdate" class="sn-toolbar__confirm" role="alertdialog" aria-label="Reload now?">
      <span>Reload now? Unsaved changes on this page will be lost.</span>
      <button type="button" class="btn btn-sm btn-primary" (click)="update()">Reload</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelUpdate()">Later</button>
    </span>
  </span>

  <button *ngIf="showSearch" type="button" class="sn-toolbar__button" (click)="search()"
          [title]="'Search the menu (' + searchShortcut + ')'" aria-label="Search the menu"
          [attr.aria-keyshortcuts]="isMac ? 'Meta+K' : 'Control+K'">
    <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
  </button>

  <span *ngIf="vm.page?.kind" class="sn-toolbar__bookmark">
    <button type="button" class="sn-toolbar__button sn-toolbar__star" [class.sn-toolbar__star--on]="vm.page.bookmarked"
            [attr.aria-pressed]="vm.page.bookmarked" aria-label="Bookmark this page" aria-haspopup="dialog"
            [attr.aria-expanded]="!!naming"
            [title]="vm.page.bookmarked ? 'Rename or remove this bookmark' : 'Bookmark this page'"
            (click)="openBookmark(vm.page)">
      <i [ngClass]="vm.page.bookmarked ? 'fa-solid fa-star' : 'fa-regular fa-star'" aria-hidden="true"></i>
    </button>
    <form *ngIf="naming" class="sn-bookmark-popover" role="dialog"
          [attr.aria-label]="naming.existing ? 'Edit bookmark' : 'Bookmark this page'"
          (ngSubmit)="saveBookmark(nameInput.value)" (keydown.escape)="$event.stopPropagation(); closeBookmark()">
      <label class="sn-bookmark-popover__title" for="sn-bookmark-name">{{ naming.existing ? 'Edit bookmark' : 'Bookmark this page' }}</label>
      <input #nameInput id="sn-bookmark-name" type="text" class="form-control form-control-sm" maxlength="120"
             [value]="naming.label" placeholder="Name this bookmark">
      <div class="sn-bookmark-popover__actions">
        <button *ngIf="naming.existing" type="button" class="btn btn-sm btn-link text-danger mr-auto" (click)="removeBookmark()">Remove</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeBookmark()">Cancel</button>
        <button type="submit" class="btn btn-sm btn-primary">{{ naming.existing ? 'Save' : 'Add' }}</button>
      </div>
    </form>
  </span>

  <app-task-notification *ngIf="showTasks"></app-task-notification>
</div>
